module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_7042.d1302869.png";